module.exports = __webpack_public_path__ + "622f1e8f00afa53f1c0762407a12b99d.MP3";